export default __webpack_public_path__ + "static/media/Diana.03e76431.jpg";